/** 门户 IP 访问受限状态（不跳登录、不清 visitorId） */
const state = {
  restricted: false,
  message: ''
}

const mutations = {
  SET_RESTRICTED(state, payload) {
    state.restricted = true
    state.message = (payload && payload.message) || '访问受限'
  },
  CLEAR_RESTRICTED(state) {
    state.restricted = false
    state.message = ''
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
